import { SendButton } from "../SendButton";
import { handleSignInWithGoogle } from "../../helpers";
import styles from "./ChatSearch.module.scss";
import { ChatSearchProps } from "../../types";

const ChatSearch = ({
  loader,
  loggedIn,
  onSubmitFn,
  placeholder,
  searchValue,
  handleChangeChatSearch,
}: ChatSearchProps) => {
  return (
    <>
      <article
        className={styles.inputWrapper}
        style={{ opacity: loader ? 0.5 : 1 }}
      >
        <textarea
          disabled={loader}
          value={searchValue}
          onChange={(e) => {
            handleChangeChatSearch && handleChangeChatSearch(e.target.value);
          }}
          placeholder={placeholder}
          rows={1}
          cols={50}
          onKeyDown={(e) => {
            if (e.key === "Enter" && loggedIn) {
              e.preventDefault();
              onSubmitFn(searchValue || "");
            }
          }}
        />
        <div className={styles.sendIcon}>
          {loggedIn ? (
            <SendButton onSubmit={() => onSubmitFn(searchValue || "")} />
          ) : (
            <button onClick={handleSignInWithGoogle}>LogIn</button>
          )}
        </div>
      </article>
    </>
  );
};

export default ChatSearch;
